import React, { ReactNode, ButtonHTMLAttributes } from "react";
import classNames from "classnames/bind";
import styles from "./button.module.scss";
import Spinner from "../spinner";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  onClick?: () => void;
  variant?: "NORMAL" | "SOLID";
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "NORMAL",
  loading = false,
  disabled = false,
  className = "",
  ...attributes
}) => {
  const isDisabled = loading || disabled;

  const cx = classNames.bind(styles);
  const classes = cx({
    normal: variant === "NORMAL",
    solid: variant === "SOLID",
    disabled: isDisabled,
  });

  return (
    <button
      className={`${classes} ${className}`}
      onClick={onClick}
      disabled={isDisabled}
      {...attributes}>
      {children}
      {loading && <Spinner />}
    </button>
  );
};

export default Button;
